import axiosInstance from '../axiosInterceptor/axiosInstance'

const updateSeasonTeam = async (data) => {
  const { orgId, seasonTeamId, name } = data
  const url = `v1/orgs/${orgId}/season-teams/${seasonTeamId}`
  return axiosInstance.patch(url, { name })
}

export default updateSeasonTeam
